import { Language, LANGUAGES } from 'domains/language';
import { useTranslation } from 'react-i18next';
import { CONTENTFUL_LOCALE_MAP } from 'utils/contentful/contentfulService';

// @TODO(juan): consider always defaulting to english in this hook if language happens to be null from i18n, in order to avoid null checks in consumers
type UseLanguage = () => {
  currentLanguage?: Language;
  currentContentfulLocale?: string;
};

/** Used to access currently selected language */
export const useLanguage: UseLanguage = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const currentLanguage = LANGUAGES.find(({ value }) => value === language);

  const currentContentfulLocale = currentLanguage ? CONTENTFUL_LOCALE_MAP[currentLanguage.value] : undefined;

  return { currentLanguage, currentContentfulLocale };
};
